/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
import '~/assets/js/global.js';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { getBrandingVar } from '~/assets/js/utils/whitelabeling.js';
import { doBackendRequest } from '~/assets/js/utils/auth-utils.js';

// General function
//

export function checkIfUserExists(email, successCallback, failureCallback) {
    const payload = {
        email,
        password: '12A-34B-34C-34d-35F',
    };
    signInEuCentral(payload, successCallback, failureCallback);
}

export function authSignIn(payload, successCallback, failureCallback) {
    signInEuCentral(payload, successCallback, failureCallback);
}

export function authSendCustomChallengeAnswer(payload, successCallback, failureCallback) {
    const { user } = payload;
    const { userPoolId } = user.pool;
    const matchEuPool = 'eu-central-1';

    if (userPoolId.match(matchEuPool)) {
        authSendCustomChallengeAnswerEuCentral(payload, successCallback, failureCallback);
    } else {
        authSendCustomChallengeAnswerUsEast(payload, successCallback, failureCallback);
    }
}

export function authForgotPassword(payload, successCallback, failureCallback) {
    authForgotPasswordEuCentral(payload, successCallback, failureCallback);
}

export function authForgotPasswordSubmit(payload, successCallback, failureCallback) {
    authForgotPasswordSubmitEuCentral(payload, successCallback, failureCallback);
}

export function authChangePassword(payload, successCallback, failureCallback) {
    authChangePasswordEuCentral(payload, successCallback, failureCallback);
}

export function authCompleteNewPassword(payload, successCallback, failureCallback) {
    authCompleteNewPasswordEuCentral(payload, successCallback, failureCallback);
}


export function authConfirmSignUp(payload, successCallback, failureCallback) {
    authConfirmSignUpEuCentral(payload, successCallback, failureCallback);
}

export function createNewUserEuCentral(password, successCallback, failureCallback) {
    const payload = {
        password,
    };
    doBackendRequest(
        'POST',
        '/api/aws/admin_create_user',
        (response) => {
            successCallback(response);
        },
        JSON.stringify(payload),
        (response) => {
            failureCallback(response);
        },
    );
}

export function changePasswordEuCentral(password, successCallback, failureCallback) {
    const payload = {
        password,
    };
    doBackendRequest(
        'POST',
        '/api/aws/current_user_change_password',
        (response) => {
            successCallback(response);
        },
        JSON.stringify(payload),
        (response) => {
            failureCallback(response);
        },
    );
}


// AUTH FOR eu-central-1
//

function initAmplifyEuCentral() {
    Amplify.configure(getBrandingVar('aws_config_eu_central'));
}
export function signInEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();
    const { email } = payload;
    const { password } = payload;
    Auth.signIn(email, password).then((user) => {
        successCallback(user);
    }).catch((err) => {
        if (err.code === 'UserNotFoundException') {
            signInUsEast(payload, successCallback, failureCallback);
        } else {
            failureCallback(err);
        }
    });
}

export function signUpEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { email } = payload;
    const { password } = payload;
    const { firstName } = payload;
    const { lastName } = payload;
    const { phoneNumber } = payload;
    const { industry } = payload;
    const { accountId } = payload;
    // eslint-disable-next-line prefer-const
    let attributes = {
        name: firstName,
        family_name: lastName,
        email,
        phone_number: phoneNumber,
        'custom:industry': industry,
    };
    if (accountId) {
        attributes['custom:accountId'] = accountId;
    }
    Auth.signUp({
        username: email,
        password,
        attributes,
    }).then((data) => {
        successCallback(data);
    }).catch((err) => {
        failureCallback(err);
    });
}

export function authSendCustomChallengeAnswerEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { user } = payload;
    const { answer } = payload;
    Auth.sendCustomChallengeAnswer(user, answer)
        .then((user) => {
            successCallback(user);
        })
        .catch((err) => {
            failureCallback(err);
        });
}

export function authForgotPasswordEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { email } = payload;
    Auth.forgotPassword(email)
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            if (err.code === 'UserNotFoundException') {
                authForgotPasswordUsEast(payload, successCallback, failureCallback);
            } else {
                failureCallback(err);
            }
        });
}

export function authForgotPasswordSubmitEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { email } = payload;
    const { code } = payload;
    const { newPassword } = payload;
    Auth.forgotPasswordSubmit(email, code, newPassword)
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            if (err.code === 'UserNotFoundException') {
                authForgotPasswordSubmitUsEast(payload, successCallback, failureCallback);
            } else {
                failureCallback(err);
            }
        });
}

export function authChangePasswordEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    // eslint-disable-next-line camelcase
    const { old_password } = payload;
    const { password } = payload;

    Auth.currentAuthenticatedUser()
        .then((user) => {
            Auth.changePassword(user, old_password, password)
                .then((resp) => {
                    successCallback(resp);
                }).catch((err) => {
                    if (err.code === 'UserNotFoundException') {
                        authChangePasswordUsEast(payload, successCallback, failureCallback);
                    } else {
                        failureCallback(err);
                    }
                });
        }).catch((err) => {
            if (err === 'not authenticated') {
                authChangePasswordUsEast(payload, successCallback, failureCallback);
            }
        });
}

export function authCompleteNewPasswordEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { signedInUser } = payload;
    const { newPassword } = payload;

    Auth.completeNewPassword(
        signedInUser,
        newPassword, {
            name: 'NA',
            family_name: 'NA',
        },
    )
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            if (err.code === 'UserNotFoundException') {
                authCompleteNewPasswordUsEast(payload, successCallback, failureCallback);
            } else {
                failureCallback(err);
            }
        });
}

export function authConfirmSignUpEuCentral(payload, successCallback, failureCallback) {
    initAmplifyEuCentral();

    const { email } = payload;
    const { code } = payload;

    Auth.confirmSignUp(email, code)
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            failureCallback(err);
        });
}

// AUTH FOR us-east-2
//
function initAmplifyUsEast() {
    Amplify.configure(getBrandingVar('aws_config'));
}


export function signInUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();
    const { email } = payload;
    const { password } = payload;
    Auth.signIn(email, password).then((user) => {
        user.create_new_user = true;
        successCallback(user);
    }).catch((err) => {
        failureCallback(err);
    });
}

export function authSendCustomChallengeAnswerUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();

    const { user } = payload;
    const { answer } = payload;
    Auth.sendCustomChallengeAnswer(user, answer)
        .then((user) => {
            successCallback(user);
        })
        .catch((err) => {
            failureCallback(err);
        });
}

export function authForgotPasswordUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();

    const { email } = payload;
    Auth.forgotPassword(email)
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            failureCallback(err);
        });
}

export function authForgotPasswordSubmitUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();

    const { email } = payload;
    const { code } = payload;
    const { newPassword } = payload;
    Auth.forgotPasswordSubmit(email, code, newPassword)
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            failureCallback(err);
        });
}

export function authChangePasswordUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();

    // eslint-disable-next-line camelcase
    const { old_password } = payload;
    const { password } = payload;

    Auth.currentAuthenticatedUser()
        .then((user) => {
            Auth.changePassword(user, old_password, password)
                .then((resp) => {
                    changePasswordEuCentral(
                        password,
                        () => { successCallback(resp); },
                        () => {},
                    );
                    // successCallback(resp)
                }).catch((err) => {
                    failureCallback(err);
                });
        });
}

export function authCompleteNewPasswordUsEast(payload, successCallback, failureCallback) {
    initAmplifyUsEast();

    const { signedInUser } = payload;
    const { newPassword } = payload;

    Auth.completeNewPassword(
        signedInUser,
        newPassword, {
            name: 'NA',
            family_name: 'NA',
        },
    )
        .then((data) => {
            successCallback(data);
        })
        .catch((err) => {
            failureCallback(err);
        });
}
